<template>
  <div class="padres-container" ref="rootRef">
    <!-- RASGADO SUPERIOR DE ANCHO TOTAL (#ebdce0) -->
    <div class="rasgado-svg rasgado-superior" aria-hidden="true">
      <svg viewBox="0 0 1200 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,0 L1200,0 L1200,25 C1100,55 950,10 800,35 C650,60 500,15 350,40 C200,65 100,20 0,40 Z" fill="#ebdce0" />
      </svg>
    </div>

    <!-- FONDO TEXTURA QUE OCUPA TODO EL ANCHO -->
    <div class="fondo-textura"></div>
    <div class="overlay-suave"></div>

    <!-- CONTENIDO INTERNO -->
    <div class="contenido-interno" ref="contenidoRef">
      <div class="frase-container">
        <h2 ref="fraseLinea1" class="frase linea1">¡Cada segundo</h2>
        <h2 ref="fraseLinea2" class="frase linea2">más cerca</h2>
        <p ref="fraseLinea3" class="frase linea3">de mi gran día!</p>
      </div>

      <div class="contador-titulo">
        <span ref="soloRef" class="solo">Solo</span>
        <span ref="faltanRef" class="faltan">Faltan</span>
      </div>

      <div ref="flechaRef" class="flecha-wrapper">
        <img src="@/assets/15.avif" alt="Flecha decorativa" class="flecha-img" />
      </div>

      <div class="contador-numeros">
        <div ref="tiempoRef1" class="tiempo">
          <span class="numero">{{ dias }}</span>
          <span class="etiqueta">Días</span>
        </div>
        <div ref="tiempoRef2" class="tiempo">
          <span class="numero">{{ horas }}</span>
          <span class="etiqueta">Horas</span>
        </div>
        <div ref="tiempoRef3" class="tiempo">
          <span class="numero">{{ minutos }}</span>
          <span class="etiqueta">Minutos</span>
        </div>
        <div ref="tiempoRef4" class="tiempo">
          <span class="numero">{{ segundos }}</span>
          <span class="etiqueta">Segundos</span>
        </div>
      </div>
    </div>

    <!-- RASGADO INFERIOR APUNTANDO HACIA ARRIBA (#ebdce0) -->
    <div class="rasgado-svg rasgado-inferior" aria-hidden="true">
      <svg viewBox="0 0 1200 60" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0,60 L1200,60 L1200,40 C1100,15 950,55 800,30 C650,5 500,50 350,25 C200,0 100,45 0,25 Z" fill="#ebdce0" />
      </svg>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const rootRef = ref(null)
    const contenidoRef = ref(null)
    const fraseLinea1 = ref(null)
    const fraseLinea2 = ref(null)
    const fraseLinea3 = ref(null)
    const soloRef = ref(null)
    const faltanRef = ref(null)
    const flechaRef = ref(null)
    const tiempoRef1 = ref(null)
    const tiempoRef2 = ref(null)
    const tiempoRef3 = ref(null)
    const tiempoRef4 = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const cuentaAtras = () => {
      const evento = new Date('2026-12-27T15:00:00')
      const tick = () => {
        const ahora = new Date()
        const diferencia = evento - ahora
        if (diferencia <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          clearInterval(timerId)
          return
        }
        dias.value = String(Math.floor(diferencia / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((diferencia / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((diferencia / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((diferencia / 1000) % 60)).padStart(2, '0')
      }
      tick()
      timerId = setInterval(tick, 1000)
    }

    onMounted(async () => {
      await nextTick()
      cuentaAtras()

      // ESTADOS INICIALES PARA ANIMACIONES INDEPENDIENTES Y FLUIDAS
      gsap.set(contenidoRef.value, { autoAlpha: 0, y: 30 })
      gsap.set([fraseLinea1.value, fraseLinea2.value, fraseLinea3.value], { autoAlpha: 0, y: -25, rotation: -2 })
      gsap.set(soloRef.value, { autoAlpha: 0, y: -30, scale: 0.85 })
      gsap.set(faltanRef.value, { autoAlpha: 0, y: 30, scale: 0.85 })
      gsap.set(flechaRef.value, { autoAlpha: 0, scale: 0, rotation: -30 })
      gsap.set([tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value], { autoAlpha: 0, y: 40, scale: 0.9 })

      const el = rootRef.value

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'back.out(1.4)' } })

          // 1. Aparición fluida del contenido general
          tl.to(contenidoRef.value, {
            autoAlpha: 1,
            y: 0,
            duration: 1
          })

          // 2. Frases superiores descienden en cascada
          tl.to(
            [fraseLinea1.value, fraseLinea2.value, fraseLinea3.value],
            {
              autoAlpha: 1,
              y: 0,
              rotation: 0,
              duration: 0.75,
              stagger: 0.12
            },
            '-=0.6'
          )

          // 3. Títulos "Solo" y "Faltan"
          tl.to(
            soloRef.value,
            { autoAlpha: 1, y: 0, scale: 1, duration: 0.65 },
            '-=0.4'
          ).to(
            faltanRef.value,
            { autoAlpha: 1, y: 0, scale: 1, duration: 0.65 },
            '-=0.45'
          )

          // 4. Flecha decorativa
          tl.to(
            flechaRef.value,
            { autoAlpha: 1, scale: 1, rotation: 0, duration: 0.7, ease: 'back.out(1.8)' },
            '-=0.3'
          )

          // 5. Bloques de tiempo con rebote fluido
          tl.to(
            [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value],
            {
              autoAlpha: 1,
              y: 0,
              scale: 1,
              duration: 0.75,
              stagger: 0.1,
              ease: 'back.out(1.6)'
            },
            '-=0.35'
          )

          // Animación continua y viva de la flecha
          gsap.to(flechaRef.value, {
            y: '+=5',
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',
            delay: 0.5
          })

          io.disconnect()
        })
      }, { threshold: 0.3 })

      if (el) io.observe(el)
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      rootRef,
      contenidoRef,
      fraseLinea1,
      fraseLinea2,
      fraseLinea3,
      soloRef,
      faltanRef,
      flechaRef,
      tiempoRef1,
      tiempoRef2,
      tiempoRef3,
      tiempoRef4,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>

<style scoped>
/* =========================
   CONTENEDOR GENERAL DE ANCHO TOTAL
========================= */
.padres-container {
  position: relative;
  width: 100%;
  min-height: 55vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 50px 0;
}

/* =========================
   FONDO TEXTURA GENERAL
========================= */
.fondo-textura {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  background-image: url('@/assets/fondotextura.avif');
  background-size: cover;
  background-position: center;
  z-index: 0;
}

.overlay-suave {
  position: absolute;
  inset: 0;
  z-index: 1;
  background: rgba(255, 255, 255, 0.55);
  backdrop-filter: blur(1px);
}

/* =========================
   RASGADOS SVG DE ANCHO TOTAL (#ebdce0)
========================= */
.rasgado-svg {
  position: absolute;
  left: 0;
  width: 100%;
  height: 45px;
  z-index: 5;
  pointer-events: none;
  overflow: hidden;
}

.rasgado-superior {
  top: 0;
}

.rasgado-inferior {
  bottom: 0;
}

.rasgado-svg svg {
  width: 100%;
  height: 100%;
  display: block;
  filter: drop-shadow(0 3px 5px rgba(0,0,0,0.04));
}

/* =========================
   CONTENIDO INTERNO
========================= */
.contenido-interno {
  position: relative;
  z-index: 4;
  width: 100%;
  max-width: 600px;
  margin: 0 auto;
  padding: 30px 20px;
  text-align: center;
  will-change: transform, opacity;
}

/* =========================
   FRASES SUPERIORES (Baby Pink / Peach)
========================= */
.frase {
  color: #df91a6 !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.7);
  will-change: transform, opacity;
}

.frase.linea1,
.frase.linea2 {
  font-family: 'Playfair Display', serif;
  font-size: 26px;
  font-weight: 500;
}

.frase.linea3 {
  font-family: 'Playfair Display', serif;
  font-size: 19px;
  margin-top: 4px;
}

/* =========================
   TÍTULO SOLO / FALTAN
========================= */
.contador-titulo {
  margin-top: 14px;
  margin-bottom: 8px;
}

.contador-titulo .solo {
  font-family: 'FeelingPassionate', cursive;
  font-size: 34px;
  display: block;
  color: #e69fb2 !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.7);
  will-change: transform, opacity;
}

.contador-titulo .faltan {
  font-family: 'Playfair Display', serif;
  font-size: 46px;
  letter-spacing: 1px;
  display: block;
  color: #df91a6 !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.7);
  will-change: transform, opacity;
}

/* =========================
   FLECHA
========================= */
.flecha-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  margin: 6px 0 14px;
  will-change: transform, opacity;
}

.flecha-img {
  width: 32px;
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
}

/* =========================
   CONTADOR NUMÉRICO
========================= */
.contador-numeros {
  display: flex;
  justify-content: space-around;
  gap: 12px;
  padding: 6px 8px 0px;
  max-width: 500px;
  margin: 0 auto;
}

.tiempo {
  display: flex;
  flex-direction: column;
  align-items: center;
  will-change: transform, opacity;
}

.numero {
  font-size: 42px;
  font-weight: bold;
  font-family: 'Oswald', sans-serif;
  color: #df91a6 !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.7);
}

.etiqueta {
  font-size: 14px;
  font-family: 'Oswald', sans-serif;
  margin-top: 4px;
  color: #e4a2b3 !important;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 420px) {
  .contador-numeros { gap: 6px; }
  .numero { font-size: 34px; }
  .frase.linea1, .frase.linea2 { font-size: 22px; }
  .contador-titulo .faltan { font-size: 38px; }
}

/* =========================
   FIX iOS (Safari)
========================= */
.frase,
.frase *,
.contador-titulo .solo,
.contador-titulo .faltan,
.numero,
.etiqueta {
  -webkit-text-fill-color: inherit !important;
  mix-blend-mode: normal !important;
}
</style>